import React from 'react';
import { Nav, Navbar, NavItem} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import logo from './images/logo.png';

import './NavbarComp.css';

export const NavbarComp = () => (
  <Navbar collapseOnSelect>
    <Navbar.Header>
      <LinkContainer exact to="/">
        <Navbar.Brand>
          <a href="/"><img alt="" src={logo}/></a>
          <div className="brand-box">
            <span className="brand-large">
              <span>P</span>
              <span>R</span>
              <span>I</span>
              <span>S</span>
              <span>T</span>
              <span>I</span>
              <span>N</span>
              <span>E</span>
            </span>
            <span className="brand-small">
              <span>I</span>
              <span>N</span>
              <span>T</span>
              <span>E</span>
              <span>R</span>
              <span>I</span>
              <span>O</span>
              <span>R</span>
              <span>&nbsp;&nbsp;</span>
              <span>D</span>
              <span>E</span>
              <span>S</span>
              <span>I</span>
              <span>G</span>
              <span>N</span>
            </span>
          </div>
        </Navbar.Brand>
      </LinkContainer>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav pullRight>
        <LinkContainer exact to="/">
          <NavItem>Projects</NavItem>
        </LinkContainer>
        <LinkContainer exact to="/service">
          <NavItem>Service</NavItem>
        </LinkContainer>
        <LinkContainer exact to="/quote">
          <NavItem>Quote</NavItem>
        </LinkContainer>
        <LinkContainer to="/contact">
          <NavItem>Contact</NavItem>
        </LinkContainer>
        <LinkContainer to="/about">
          <NavItem>About</NavItem>
        </LinkContainer>
      </Nav>
    </Navbar.Collapse>
  </Navbar> 
)
            
export default NavbarComp;



// WEBPACK FOOTER //
// ./src/NavbarComp.js